import { useEffect, useRef, useState, useCallback, useLayoutEffect } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import GoalItem from "./GoalItem";
import { Swiper, SwiperSlide } from "swiper/react";
import AllDataClass from "pages/common/AllDataClass";
import { useTranslation } from "react-i18next";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "./SelectGoal.scss";
// import No1 from "../../images/no1.jpg";
// import No2 from "../../images/no2.jpg";
// import PromiseModal from "./PromiseModal";
// import GameService from "../../service/GameService";

const SelectGoal = (): JSX.Element => {
  const { t } = useTranslation();
  const GoverningGoals: any = AllDataClass.getEnabledGoverningGoals();

  const navigate = useNavigate();
  const [goal0, setGoal0] = useState({ goalid: null, selected: null, texts: [] });
  const [goal1, setGoal1] = useState({ goalid: null, selected: null, texts: [] });
  const [goal2, setGoal2] = useState({ goalid: null, selected: null, texts: [] });
  const [isGiveMeGoals, setIsGiveMeGoals] = useState(false);
  const [selectedItem, setSelectedItem] = useState(0);
  const [swipers, setSwipers] = useState(GoverningGoals);
  // const [promiseModalOpen, setPromiseModalOpen] = useState(false);
  // const [candidateNo, setCandidateNo] = useState(1);
  const button_wrap_ref = useRef(null);
  const explain_ref = useRef(null);
  const GoalSets: any[] = AllDataClass.getGovGoalSets();
  // const [averageBenefitPass, setAverageBenefitPass] = useState(false);
  // const [lower40BenefitPass, setLower40BenefitPass] = useState(false);
  // const [PYI1Pass, setPYI1Pass] = useState(false);

  const [swiperInstance, setSwiperInstance] = useState(null);
  // const [updateDebtRatio, setUpdateDebtRatio] = useState([]);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    if (swiperInstance) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  const getRandomInt = (max: number) => {
    return Math.floor(Math.random() * max);
  };

  useEffect(() => {
    console.log(goal0);
    console.log(goal1);
    console.log(goal2);
  }, [goal0, goal1, goal2]);

  const onClickHandler = (idx: number) => {
    console.log(idx);
    console.log({ swipers });
    var itemlist = swipers;
    console.log({ itemlist });
    var selectedItemCnt = 0;
    console.log(selectedItemCnt);
    if (itemlist[idx].selected === true) {
      console.log("1");
      itemlist[idx].selected = false;
    } else {
      console.log("2");
      itemlist.forEach((item: any) => {
        item.selected && selectedItemCnt++;
      });
      if (selectedItemCnt < 3) {
        itemlist[idx].selected = true;
      }
    }
    var selectIdx = 0;

    setGoal0({ goalid: null, selected: null, texts: [] });
    setGoal1({ goalid: null, selected: null, texts: [] });
    setGoal2({ goalid: null, selected: null, texts: [] });

    console.log(itemlist);
    itemlist.forEach((item: any, idx: number) => {
      console.log(idx, item);
      if (item.selected === true) {
        switch (selectIdx) {
          case 0:
            console.log("00");
            setGoal0(item);
            break;
          case 1:
            console.log("11");
            setGoal1(item);
            break;
          case 2:
            console.log("22");
            setGoal2(item);
            break;
        }
        selectIdx++;
      }
    });
    button_wrap_ref.current.style.display = "none";
    explain_ref.current.style.display = "flex";
    setSwipers([...itemlist]);
    setIsGiveMeGoals(false);
    setSelectedItem(idx);
    explain_ref.current.classList.remove("hide");
  };

  const setGoalAuto = () => {
    button_wrap_ref.current.style.display = "none";
    explain_ref.current.style.display = "flex";
    var random = getRandomInt(1);
    var itemlist = swipers;
    var selectGoalIdx = 0;
    itemlist.map((item: any) => {
      GoalSets[random].forEach((goalid: any) => {
        if (item.goalid === goalid) {
          item.selected = true;
          switch (selectGoalIdx) {
            case 0:
              setGoal0(item);
              break;
            case 1:
              setGoal1(item);
              break;
            case 2:
              setGoal2(item);
              break;
          }
          selectGoalIdx++;
          return;
        }
      });
    });
    setSwipers(itemlist);
    setIsGiveMeGoals(true);
  };
  const setGoalSelct = () => {
    button_wrap_ref.current.style.display = "none";
    // explain_ref.current.classList.add("hide");
    explain_ref.current.style.display = "flex";
    setGoal0({ goalid: null, selected: null, texts: [] });
    setGoal1({ goalid: null, selected: null, texts: [] });
    setGoal2({ goalid: null, selected: null, texts: [] });
    setIsGiveMeGoals(false);
  };

  const getExplain = () => {
    var retVal = new Array(3);
    var goals = [goal0, goal1, goal2];

    goals.forEach((goal) => {
      if (goal?.goalid?.length > 0) {
        retVal.push(
          <div className="goal-explain-box">
            <div className="explain">
              <div className="selected-goal-title">{goal.texts[0]}</div>
              <span>- {goal.texts[4]}</span>
              <span>- {goal.texts[5]}</span>
              <span>- {goal.texts[6]}</span>
            </div>
          </div>
        );
      } else {
        retVal.push(
          <div className="goal-explain-box">
            <div className="explain"></div>
          </div>
        );
      }
    });
    return retVal;
  };

  // const showPromise = (candidateNo: number) => {
  //   console.log(candidateNo);
  //   setCandidateNo(candidateNo);
  //   setPromiseModalOpen(true);
  //   return candidateNo;
  // };

  // const handlerClosePromiseModal = () => {
  //   setPromiseModalOpen(false);
  //   return;
  // };
  // const handlerClosePromiseModalAndSubmit = () => {
  //   setPromiseModalOpen(false);
  //   submitPlan(candidateNo);
  //   return;
  // };
  // const selectedPolicyLists = [
  //   ["P0801", "P0802", "P0803"],
  //   ["P0701", "P0702", "P0703", "P0704", "P0705"],
  // ];

  // const getGoalScore = (selectedGoals: any[]) => {
  //   var points = new Array();
  //   console.log(selectedGoals);
  //   console.log(AllDataClass.selectedList);
  //   selectedGoals.map((selectedGoal: any, idx: number) => {
  //     var starPoint = 0;
  //     var isSuccessed = [];
  //     // var lowerTax = ["P0015", "P0016", "P0017", "P0018"];
  //     // var muchTax = ["P0011", "P0012", "P0013", "P0014"];
  //     // var lowerCopTax = ["P0035", "P0036", "P0037", "P0038"];
  //     // var muchCopTax = ["P0031", "P0032", "P0033", "P0034"];
  //     var basicInsure = ["P0201", "P0202", "P0203", "P0204"];
  //     // 경제활성화 (B005) 별점 배열
  //     var B005P1 = [
  //       "P0015",
  //       "P0016",
  //       "P0017",
  //       "P0018",
  //       "P0035",
  //       "P0036",
  //       "P0037",
  //       "P0038",
  //       "P0301",
  //       "P0311",
  //       "P0701",
  //       "P0702",
  //       "P0703",
  //       "P0704",
  //     ];
  //     var B005M1 = [
  //       "P0011",
  //       "P0012",
  //       "P0013",
  //       "P0014",
  //       "P0031",
  //       "P0032",
  //       "P0033",
  //       "P0034",
  //       "P0071",
  //       "P0072",
  //       "P0081",
  //       "P0082",
  //       "P0704",
  //     ];
  //     var B007P1 = ["P0802"];
  //     var B007M1 = ["P0705", "P0801"];
  //     var B008P1 = ["P0191", "P0301", "P0311", "P0701", "P0702", "P0705", "P0803"];
  //     var B008P2 = ["P0192", "P0035", "P0036", "P0037", "P0038"];
  //     var B008M1 = ["P0071", "P0072", "P0081", "P0082", "P0802"];
  //     var B008M2 = ["P0031", "P0032", "P0033", "P0034"];
  //     // var otherTax = ["P0301", "P0311"];
  //     var goalID = selectedGoal.goalid;
  //     // var policy_list = new Array();

  //     if (goalID === "B007") {
  //       isSuccessed.push(averageBenefitPass);
  //       // 소득 1, 2분위는 별점 1개
  //       isSuccessed.push(lower40BenefitPass);
  //       isSuccessed.push(lower40BenefitPass);
  //       // PYI가 낮을 수록 노인 지원은 약해진다.
  //       isSuccessed.push(!PYI1Pass);
  //       isSuccessed.push(updateDebtRatio[updateDebtRatio.length - 1] <= 150);
  //       AllDataClass.selectedList?.forEach((p1: string) => {
  //         basicInsure.forEach((p2) => {
  //           if (p1 === p2) {
  //             isSuccessed.push(true);
  //           }
  //         });
  //         B007P1.forEach((p2) => {
  //           if (p1 === p2) {
  //             starPoint++;
  //           }
  //         });
  //         B007M1.forEach((p2) => {
  //           if (p1 === p2) {
  //             starPoint--;
  //           }
  //         });
  //       });

  //       isSuccessed?.forEach((success) => {
  //         if (success === true) {
  //           starPoint++;
  //           // } else {
  //           //   starPoint--;
  //         }
  //         if (updateDebtRatio[updateDebtRatio.length - 1] > 150) {
  //           starPoint--;
  //         }
  //       });
  //     } else if (goalID === "B005") {
  //       AllDataClass.selectedList?.forEach((p1: string) => {
  //         B005P1.forEach((p2) => {
  //           if (p1 === p2) {
  //             starPoint++;
  //           }
  //         });
  //         B005M1.forEach((p2) => {
  //           if (p1 === p2) {
  //             starPoint--;
  //           }
  //         });
  //       });
  //     } else if (goalID === "B008") {
  //       AllDataClass.selectedList?.forEach((p1: string) => {
  //         B008P1.forEach((p2) => {
  //           if (p1 === p2) {
  //             starPoint++;
  //           }
  //         });
  //         B008P2.forEach((p2) => {
  //           if (p1 === p2) {
  //             starPoint = starPoint + 2;
  //           }
  //         });
  //         B008M1.forEach((p2) => {
  //           if (p1 === p2) {
  //             starPoint--;
  //           }
  //         });
  //         B008M2.forEach((p2) => {
  //           if (p1 === p2) {
  //             starPoint = starPoint - 2;
  //           }
  //         });
  //       });
  //     }
  //     points.push(starPoint);
  //   });

  //   return points;
  // };

  // const submitPlan = async (candidateNo: number) => {
  //   const policyLists = selectedPolicyLists[candidateNo - 1];
  //   policyLists.forEach((policy) => {
  //     AllDataClass.addSelectedList(policy);
  //   });
  //   const BaseGoalScore = AllDataClass.getBaseGoalScore();
  //   const goalScore = AllDataClass.getGoalScore();
  //   const updateDebtRatio = AllDataClass.getBaseDebtRatiobyPolicy(policyLists);
  //   const candidateName = ["이재명 후보님11", "김문수 후보님11"];

  //   if (goalScore[0] !== 0 && goalScore[0] - BaseGoalScore[0] > 0) {
  //     setAverageBenefitPass(true);
  //   } else {
  //     setAverageBenefitPass(false);
  //   }
  //   // 소들대체율 (1, 2분위) 40 이상이면 목표 달성
  //   if (goalScore[1] !== 0 && goalScore[1] - BaseGoalScore[1] > 0) {
  //     setLower40BenefitPass(true);
  //   } else {
  //     setLower40BenefitPass(false);
  //   }
  //   // PYI1이 31.8 이하면 목표 달성
  //   if (goalScore[2] !== 0 && goalScore[2] - BaseGoalScore[2] < 0) {
  //     setPYI1Pass(true);
  //   } else {
  //     setPYI1Pass(false);
  //   }

  //   try {
  //     GameService.createGame(
  //       AllDataClass.getGameId(),
  //       // AllDataClass.getUserName(),
  //       candidateName[candidateNo - 1],
  //       JSON.stringify(GoverningGoals),
  //       JSON.stringify(policyLists),
  //       goalScore[2],
  //       JSON.stringify(updateDebtRatio),
  //       150,
  //       JSON.stringify(getGoalScore(GoverningGoals))
  //     );

  //     navigate("/result", {
  //       state: {
  //         selectedGoals: GoverningGoals,
  //         gameid: AllDataClass.getGameId(),
  //         // username: AllDataClass.getUserName(),
  //         username: candidateName[candidateNo - 1],
  //         debt: updateDebtRatio,
  //         selectedPolicyLists: policyLists,
  //         starScore: getGoalScore(GoverningGoals),
  //         pyi: goalScore[2],
  //       },
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  return (
    <div className="select-goal-root">
      {/* <PromiseModal
        promiseModalOpen={promiseModalOpen}
        handleClose={handlerClosePromiseModal}
        handler={handlerClosePromiseModalAndSubmit}
        candidateNo={candidateNo}
      />
      <div className="candidate-title">{t("pledges-title")}</div>
      <div className="candidate-wrap">
        <div
          className="candidate color1"
          onClick={() => {
            showPromise(1);
          }}
        >
          <div className="candidate-photo">
            <img src={No1} />
          </div>
          <div className="candidate-text">
            <div className="candidate-name">{t("candidate1")}</div>
            <div className="candidate-promise">{t("PledgesShortcut")}</div>
            <div className="candidate-fiscal-promise">
              <div className="title">{t("MajorFiscalPledges")}</div>
              <div className="contents">
                <span>○ {t("LeePledge1")}</span>
                <span>○ {t("LeePledge2")}</span>
                <span>○ {t("LeePledge3")}</span>
                <span>{t("inpolicymenu")}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          className="candidate color2"
          onClick={() => {
            showPromise(2);
          }}
        >
          <div className="candidate-photo">
            <img src={No2} />
          </div>
          <div className="candidate-text">
            <div className="candidate-name">{t("candidate2")}</div>
            <div className="candidate-promise">{t("PledgesShortcut")}</div>
            <div className="candidate-fiscal-promise">
              <div className="title">{t("MajorFiscalPledges")}</div>
              <div className="contents">
                <span>○ {t("KimPledge1")}</span>
                <span>○ {t("KimPledge2")}</span>
                <span>○ {t("KimPledge3")}</span>
                <span>○ {t("KimPledge4")}</span>
                <span>{t("inpolicymenu")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="candidate-wrap noborder">
        <div className="candidate noborder">
          <div className="button-wrap">
            <button className="buttons close" onClick={() => submitPlan(1)}>
              <span>{t("go-result")}</span>
            </button>
          </div>
        </div>
        <div className="candidate noborder">
          <div className="button-wrap">
            <button className="buttons close" onClick={() => submitPlan(2)}>
              <span>{t("go-result")}</span>
            </button>
          </div>
        </div>
      </div> */}
      <div className="select-goal-title">{t("goaltitle")}</div>
      <div className="select-goal-selected-goals">
        {goal0?.goalid?.length > 0 ? (
          <div className={`goal-size goal-${goal0.goalid}`} />
        ) : (
          <div className="goal-size goal-number-1" />
        )}
        {goal1?.goalid?.length > 0 ? (
          <div className={`goal-size goal-${goal1.goalid}`} />
        ) : (
          <div className="goal-size goal-number-2" />
        )}
        {goal2?.goalid?.length > 0 ? (
          <div className={`goal-size goal-${goal2.goalid}`} />
        ) : (
          <div className="goal-size goal-number-3" />
        )}
      </div>
      <div className="goal-explain-wrap">
        <div className="goal-select-button-wrap" ref={button_wrap_ref}>
          <button
            onClick={() => {
              setGoalAuto();
            }}
            className="buttons give-me-goals"
          >
            <span>{t("givemegoals")}</span>
          </button>
          <button
            onClick={() => {
              setGoalSelct();
            }}
            className="buttons choose-my-own"
          >
            <span>{t("choosemyown")}</span>
          </button>
        </div>
        <div className="goal-explain" ref={explain_ref}>
          {getExplain()}
          {/* <div className="goal-explain-box">
            <div className="explain">
              {isGiveMeGoals === true ? goal0.texts[0] : swipers[selectedItem].texts[4]}
            </div>
          </div>
          <div className="goal-explain-box">
            <div className="explain">
              {isGiveMeGoals === true ? goal1.texts[0] : swipers[selectedItem].texts[5]}
            </div>
          </div>
          <div className="goal-explain-box">
            <div className="explain">
              {isGiveMeGoals === true ? goal2.texts[0] : swipers[selectedItem].texts[6]}
            </div>
          </div> */}
        </div>
      </div>
      <div>
        <Swiper
          slidesPerView={3}
          spaceBetween={10}
          loop={true}
          // autoplay={{
          //   delay: 5000,
          //   disableOnInteraction: false,
          // }}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          {swipers.map((goal: any, idx: number) => (
            <SwiperSlide
              key={idx}
              onClick={() => {
                onClickHandler(idx);
              }}
            >
              <GoalItem
                selected={goal.selected}
                goalname={goal.texts[0]}
                className={goal.goalid}
                onClickHandler={onClickHandler}
              />
            </SwiperSlide>
          ))}
          {/* <div className="swiper-button-wrap">
            <button className="custom-button prev" ref={prevRef} />
            <button className="custom-button next" ref={nextRef} />
          </div> */}
        </Swiper>
      </div>
      <div className="navigation-button-wrap">
        <button
          onClick={() => {
            navigate("/howtoplay");
          }}
          className="bottom-button button-back"
        >
          <span>{t("back")}</span>
        </button>
        <button
          disabled={!goal0?.goalid?.length || goal0?.goalid?.length <= 0}
          onClick={() => {
            var goalList = new Array();
            if (goal0?.goalid?.length > 0) goalList.push(goal0);
            if (goal1?.goalid?.length > 0) goalList.push(goal1);
            if (goal2?.goalid?.length > 0) goalList.push(goal2);
            navigate("/main", {
              state: { selectedGoals: [...goalList] },
            });
          }}
          className="bottom-button button-next"
        >
          <span>{t("play2")}</span>
        </button>
      </div>
    </div>
  );
};

export default SelectGoal;
